import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import Message from '../containers/Message';
import Instructions from '../containers/Instructions';
import Snackbar from '../../../components/Snackbar';
import Popup from '../../Modal/PopUp';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import FilterDropdown from '../../Modal/FilterDropdown';
import { firestore } from '../../../configs/environments/firebase/firebaseApp';
import { Pagination } from '@material-ui/lab';
import {
  deleteMessage,
  readMessage,
  saveMessage,
} from '../../../store/actions/UserAction';

const filter = '/img/icons/filters.svg';

function Messages(props) {
  const {
    messagesLaw,
    deleteMessage,
    readMessage,
    saveMessage,
    userUid,
    page,
    totalPage,
    handleChangePage,
  } = props
  
  const [expanded, setExpanded] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });
  const [open, setOpen] = useState(false);
  const [msgToDelete, setMsgToDelete] = useState(null);

  const mobileVersion = useMediaQuery('(max-width: 1279px)');

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickDelete = (message) => {
    setOpen(true);
    setMsgToDelete(message);
  };
  const confirmDelete = () => {
    setOpen(false);
    setExpanded(false);
    deleteMessage(msgToDelete.uid, messagesLaw, userUid).then((res) => {
      setFeedbackMessage({
        open: true,
        message: 'Mensaje eliminado con éxito',
        variant: 'success',
      });
    });
  };

  const handleChange = (msg, index) => (event, isExpanded) => {
    setExpanded(isExpanded ? index : false);

    if (!msg.read) {
      //console.log(msg.read)
      readMessage(msg.uid, messagesLaw, userUid);
    }
  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  const handleSave = (msg) => {
    console.log(msg)
    if(!msg.save){

      saveMessage(msg.uid, messagesLaw, userUid)
      .then(res => {
        setFeedbackMessage({
          open: true,
          message: 'Has agregado un contacto exitosamente',
          variant: 'success',
        });
      })

    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [option, setOption] = useState('week');
  const [apply, setApply] = useState(false);

  const handleClickDropdown = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOption = (event, option) => {
    setApply(false);
    setOption(option);
  };
  const handleCloseDropdown = () => {
    setAnchorEl(null);
  };

  const openDropdown = Boolean(anchorEl);
  const id = openDropdown ? 'simple-popover' : undefined;
  
  return (
    <>
      <FilterDropdown
        id={id}
        open={openDropdown}
        anchorEl={anchorEl}
        onClose={handleCloseDropdown}
        handleOption={handleOption}
        option={option}
        // applyFilter={applyFilter}
      />
      <div style={isMobile ? { padding: '0 8px' } : null}>
        <div
          className="tabpanel-subhead"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <h4 style={{ color: '#013957', marginBottom: 16 }}>
            Todos los mensajes
          </h4>

            <button 
              className="button-filter"
              style={{top:'unset'}}
              onClick={handleClickDropdown}
            >
              <img
                src={filter}
                style={{ marginRight: 8 }}
                width="24px"
                height="24px"
                alt="icono de filtro"
              />
              <span
                style={{
                  color: '#10587f',
                  fontSize: '14px',
                  marginRight: '10px',
                  verticalAlign: '30%',
                }}
              >
                Filtrar
              </span>
            </button>
        </div>
        {mobileVersion && (
          <div
            className="instructions-wrapper"
            style={{ borderBottom: '0.5px solid #e7e7e7', marginBottom: 23 }}
          >
            <Instructions />
          </div>
        )}
      </div>

      {messagesLaw && messagesLaw.map((message, index) => {
        return (
          <Message
            expanded={expanded === index}
            onChange={handleChange(message, index)}
            handleSave={handleSave}
            key={index}
            message={message}
            handleClickDelete={handleClickDelete}
          />
        );
      })}

{(totalPage && totalPage <= 1) || totalPage === 0 ?
        null :
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Pagination
            color="primary"
            page={page}
            count={totalPage}
            onChange={handleChangePage}
          />
        </div>
      }
      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '68px' : '80px'}
      />
      <Popup
        open={open}
        handleClose={handleClose}
        title="¿Seguro que deseas eliminar este mensaje?"
        subtitle="Al eliminar un contacto pierdes interacción con un cliente potencial, para regresar oprime el botón CANCELAR."
        primaryButton={true}
        primaryButtonVariant="primarySolidOutlined"
        primaryButtonText="Sí, Eliminar"
        primaryFunction={confirmDelete}
        secondaryButton={true}
        secondaryButtonVariant="primary"
      />
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  deleteMessage: (id, arrayMessage, userUid) =>
    dispatch(deleteMessage(id, arrayMessage, userUid)),
  readMessage: (id, arrayMessage, userUid) =>
    dispatch(readMessage(id, arrayMessage, userUid)),
  saveMessage: (id, arrayMessage, userUid) => 
    dispatch(saveMessage(id, arrayMessage ,userUid))
  });

export default connect(null, mapDispatchToProps)(Messages);
